// EINE Stelle für „Session abgelaufen": die App registriert hier genau einen Handler (#1),
// der QueryClient-onError ruft ihn bei jedem 401 auf. Kein verstreutes 401-Handling.
type Handler = () => void

let handler: Handler | null = null

export function setUnauthorizedHandler(h: Handler | null): void {
  handler = h
}

export function notifyUnauthorized(): void {
  handler?.()
}
